import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useTheme } from "next-themes";
import { Palette, Sun, Moon } from "lucide-react";

export default function ThemePage() {
  const { theme } = useTheme();
  
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="space-y-8">
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center gap-3">
            <Palette className="h-8 w-8 text-primary" />
            <h1 className="text-3xl font-bold">Configuração de Tema</h1>
          </div>
          <p className="text-muted-foreground text-lg">
            Escolha entre o tema claro ou escuro conforme sua preferência
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {/* Controle de Tema */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Palette className="h-5 w-5" />
                Alternar Tema
              </CardTitle>
              <CardDescription>
                Clique no botão abaixo para trocar entre o tema claro e escuro
              </CardDescription>
            </CardHeader>
            <CardContent className="flex justify-center pt-4">
              <div className="text-center">
                <p className="text-sm text-muted-foreground">
                  Use o controle na sidebar para alternar temas
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Preview do Tema Atual */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                {theme === "light" ? (
                  <Sun className="h-5 w-5" />
                ) : (
                  <Moon className="h-5 w-5" />
                )}
                Tema Atual: {theme === "light" ? "Claro" : "Escuro"}
              </CardTitle>
              <CardDescription>
                Visualização das cores do tema selecionado
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4" data-tour="color-preview">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <div className="h-8 bg-background border rounded flex items-center justify-center text-sm">
                    Fundo
                  </div>
                  <div className="h-8 bg-card border rounded flex items-center justify-center text-sm">
                    Card
                  </div>
                  <div className="h-8 bg-primary text-primary-foreground rounded flex items-center justify-center text-sm">
                    Primário
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="h-8 bg-secondary text-secondary-foreground rounded flex items-center justify-center text-sm">
                    Secundário
                  </div>
                  <div className="h-8 bg-muted text-muted-foreground rounded flex items-center justify-center text-sm">
                    Muted
                  </div>
                  <div className="h-8 bg-accent text-accent-foreground rounded flex items-center justify-center text-sm">
                    Accent
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Informações Importantes</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3" data-tour="theme-info">
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
              <p className="text-sm text-muted-foreground">
                <strong>Editor de Documentos:</strong> Independente do tema escolhido, 
                o editor de documentos sempre manterá o fundo branco com texto preto 
                para melhor legibilidade e impressão.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
              <p className="text-sm text-muted-foreground">
                <strong>Tema Padrão:</strong> O sistema inicia com o tema claro baseado 
                nas cores da página inicial de login.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
              <p className="text-sm text-muted-foreground">
                <strong>Mudança de Tema:</strong> A alteração é aplicada instantaneamente 
                em toda a aplicação e será lembrada nas próximas visitas.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}